import angular from 'angular';

function OrderItemDonationDirective() {
  OrderItemDonationController.$inject = ['$scope'];
  function OrderItemDonationController($scope) {
    $scope.orderItemDonation = 'Your spankin new order.item.donation!';
  }

  return {
    restrict: 'A',
    replace: true,
    templateUrl: 'common/directives/order/item/donation/donation.tpl.html',
    scope: {
      model: '=',
      options: '@',
    },

    link: function ($scope, $element, $attrs) {
      // Modified after controller runs
    },

    controller: OrderItemDonationController,
  };
}

export const OrderItemDonationDirectiveModule = angular
  .module('acme.common.directive.order.item.donation', [])
  .directive('orderItemDonation', OrderItemDonationDirective).name;
